<template>
    <div class="custom-modal-text text-left">
        <b-card
            bg-variant="light"
            header="Upload Model.csv file"
            header-class="card-header  p-3 h5"
            header-text-variant="black"
            header-tag="header"
        >
            <div v-if="!hCalculationData.massPerUnit || !hCalculationData.city">
                <vue-dropzone
                    :id="customRef"
                    :ref="customRef"
                    :options="{
                        url: '/',
                        clickable: false,
                        dictDefaultMessage: `You need to choose City and Mass Per Unit to upload the Model.csv file</i>`
                    }"
                />
            </div>
            <vue-dropzone
                v-else
                :id="customRef"
                :ref="customRef"
                class="h-100 d-flex justify-content-center align-items-center flex-wrap"
                :options="dropzoneOptions"
                @vdropzone-sending="sendingFile"
                @vdropzone-queue-complete="queueComplete"
            />

            <div class="d-flex justify-content-center mt-2">
                <button
                    class="btn btn-success waves-effect waves-light"
                    data-animation="fadein"
                    data-overlaycolor="#38414a"
                    @click="uploadFiles(customRef)"
                >
                    Upload files
                </button>
            </div>
        </b-card>
    </div>
</template>

<script>
import vueDropzone from 'vue2-dropzone';

export default {
    components: { vueDropzone },

    props: {
        hCalculationData: {
            type: Object,
            required: false,
            default: null
        },

        refProps: {
            type: String,
            required: false,
            default: ''
        }
    },

    data() {
        return {
            dropzoneRelativePath: '/h-calculations'
        };
    },

    computed: {
        dropzoneOptions() {
            const options = {
                url: process.env.VUE_APP_API_URL + this.dropzoneRelativePath,
                thumbnailWidth: 150,
                maxFilesize: 50,
                timeout: 120000,
                uploadMultiple: true,
                acceptedFiles: '.csv,',
                autoProcessQueue: false,
                dictDefaultMessage:
                    "Click Here </br> or </br> Drop Model.csv file <i class='fe-upload'></i>",
                withCredentials: true,
                parallelUploads: 100
            };

            return options;
        },

        customRef() {
            if (this.refProps) {
                return this.refProps;
            }

            return (
                Math.random()
                    .toString(36)
                    .substring(2, 30)
                    .match(/[a-zA-Z]+/g)
                    .join('') + 'FileDropzone'
            );
        }
    },

    methods: {
        sendingFile(file, xhr, formData) {
            formData.append('isSettingFile', false);

            formData.append(
                'hCalculationData',
                JSON.stringify({
                    ...this.hCalculationData,
                    wallBridgePercentage:
                        this.hCalculationData.wallBridgePercentage / 100,
                    climate: this.hCalculationData.climate,
                    massPerUnit: this.hCalculationData.massPerUnit.key
                })
            );

            xhr.setRequestHeader(
                'cluid',
                JSON.parse(window.localStorage.getItem('auth.currentUser')).id
            );

            return formData;
        },

        async uploadFiles(dropZoneRef) {
            this.$refs[dropZoneRef].processQueue();
        },

        queueComplete() {
            this.$bvToast.toast(
                'Model.csv has been uploaded, and tables have been created',
                {
                    title: 'Success!',
                    variant: 'success',
                    solid: true
                }
            );
            this.$refs[this.customRef].removeAllFiles();
        }
    }
};
</script>
